<template>

  <table class="table table-hover">
    <thead class="table-thead-sticky">
      <tr>
        <th-sort
          field="date_close"
          :value="sort"
          @input="setSort">
          {{ $t('Deadline') }}
          </th-sort>
        <th-sort
          field="title"
          :value="sort"
          @input="setSort">
          {{ $t('Title') }}
          </th-sort>
        <th-sort
          field="company_id"
          :value="sort"
          @input="setSort">
          {{ $t('Company') }}
          </th-sort>
        <th-sort
          field="publicate"
          :value="sort"
          @input="setSort">
          Status
          </th-sort>
        <th>
          {{ $t('Pipeline') }}
          </th>
        <th-sort
          field="owner_user_id"
          :value="sort"
          @input="setSort">
          {{ $t('Team') }}
          </th-sort>
      </tr>
    </thead>
    <tbody>
      <JobListDefaultItem
        v-for="(job, index) in jobs"
        :key="index"
        :job="job" />
    </tbody>
  </table>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import JobListDefaultItem from './JobListDefaultItem'

export default {
  name: 'JobList',
  components: {
    ThSort,
    JobListDefaultItem
  },
  props: {
    'jobs': {
      type: Array,
      required: true
    },
    'sort': {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  metaInfo () {
    return {
      title: this.$t('Jobs/Pools')
    }
  },
  created () {
  },
  methods: {
    setSort (newSort) {
      this.$emit('setSort', newSort)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/JobList/JobListDefault.vue